import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import { DashboardContainerProps } from "../../../interfaces/containers";
import Dashboard from "../../../pages/Profile/Dashboard/Dashboard";

function mapStateToProps(state: DashboardContainerProps) {
    return {
        user: state.auth.user
    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);